module.exports = __webpack_public_path__ + "img/bg_1.6fad2a2e.png";